import { ReactComponent as CloseIcon } from '../../images/icons/close.svg'

const Filter = ({ label, onDelete, filterColor, onClick, hideDelete = false }) => {
  const handleKeyPress = (event, callback) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      callback()
    }
  }

  const handleDelete = (event) => {
    event.stopPropagation()
    onDelete()
  }

  const content = (
    <>
      <div>{label}</div>
      <div
        role={hideDelete ? undefined : 'button'}
        tabIndex={hideDelete ? undefined : 0}
        aria-hidden={hideDelete || undefined}
        aria-label={hideDelete ? undefined : `Remove ${label} filter`}
        className={`icon smaller left-margin w-embed ${hideDelete ? 'filter-delete-hidden' : ''}`}
        onClick={hideDelete ? undefined : handleDelete}
        onKeyDown={
          hideDelete ? undefined : (event) => handleKeyPress(event, () => handleDelete(event))
        }
      >
        <CloseIcon />
      </div>
    </>
  )

  if (onClick) {
    return (
      <div
        className={`filter-spec-div is-clickable ${filterColor || ''}`}
        onClick={onClick}
        onKeyDown={(event) => handleKeyPress(event, onClick)}
        role="button"
        tabIndex={0}
      >
        {content}
      </div>
    )
  }

  return <div className={`filter-spec-div ${filterColor || ''}`}>{content}</div>
}

export default Filter
